<template>
	<div class="radio-menu-container">
		<AnemicButton
			v-for="option in options"
			:key="option.value"
			class="radio-menu-button"
			:class="{ selected: selection === option.value }"
			v-bind="$attrs"
			v-on="$listeners"
			@click="$emit('change-selection', option.value)"
		>
			{{ option.text }}
		</AnemicButton>
	</div>
</template>

<script>
export default {
	name: 'ButtonGroup',
	props: {
		selection: { type: String },
		options: { type: Array },
	},
};
</script>

<style scoped lang="scss">
.radio-menu-container {
	display: inline-flex;

	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;

	.radio-menu-button {
		font-size: 12px !important;
		color: #666767 !important;
		border-radius: 6px !important;
		font-weight: normal !important;
		background: transparent !important;

		&.selected {
			color: #6363ed !important;
			border: 1px solid #e7eaf3 !important;
			background: var(--bg-color) !important;
			box-shadow: 0px 1px 2px var(--shadow-color) !important;
		}
	}
}
</style>
